<div tabindex="0" class="ngx-dropdown-container" >
    <button (click)="showDropdown()" (keyup.enter)="showDropdown()" type="button" tabindex="-1" class="ngx-dropdown-button">
      
        <span class="display-text">
            {{(selectedItemName?selectedItemName: placeholder)}}
              </span>
              <span *ngIf="selectedItemName && isListing" 
               class="icon-close" (click)="clearSelectedItem();displayList=!displayList">
               <img alt="" src="assets/images/icons/close-popup.svg">
              </span>
              <span class="nsdicon-angle-down" style="bottom: -1px;"></span>
    </button>
    <div class="ngx-dropdown-list-container" *ngIf="displayList">
        
    <div class="search-wrap" *ngIf="searchShow">
      <input id="searchInput" type="text" class="form-control" placeholder="Search" (keyup)="checkLimit($event)" #searchBox
        [(ngModel)]="searchText" (ngModelChange)="onSearch()" tabindex="0" appAutofocus appPreventFirstSpace>
    </div>
        
    <ul class="available-items">
      
        <li *ngIf="!isLoading && (!_dataArr?.length || filteredArr?.length === 0)">No data found</li>
        <li #listitem tabindex="0" (click)="selectItem(item);" role="listitem" [hidden]="filteredArr?.length === 0"
          *ngFor="let item of filteredArr;let i = index" [ngClass]="{ active: focusedItemIndex == i }">
          <div>{{item[label]}}</div>
        </li>
      </ul>
    </div>
    
</div>
